import { EpgViewConfig } from '@24i/nxg-sdk-epg/src/types';

const config: EpgViewConfig = {
    pixelsPerMin: 6.86,
    currentTimeUpdateInterval: 60,
    visibleChunkSizeViewports: 2,
};

export default config;
